module.exports = __webpack_public_path__ + "img/31.a795695a.png";